export default function(fields) {
  return {
    value: fields && fields.fileUrls && fields.fileUrls.map(item => item.url)
  }
}
